import { jsx } from "react/jsx-runtime";
import { Stack, useTheme } from "@mui/material";
import { ValidationSummaryRow } from "./components/ValidationSummaryRow.js";
import { useCreateValidationSummary } from "./hooks/useCreateValidationSummary.js";
function ValidationSummary(props) {
  const {
    items,
    testId = "validation-summary-root",
    textColor = {},
    hideIcons = false,
    emptyFallback = null,
    iconsAlignment = "top"
  } = props;
  const theme = useTheme();
  const {
    valid: validTextColor = (theme.vars ?? theme).palette.text.secondary,
    neutral: neutralTextColor = (theme.vars ?? theme).palette.text.secondary,
    invalid: invalidTextColor = (theme.vars ?? theme).palette.text.secondary
  } = textColor;
  const validationItems = useCreateValidationSummary(props, theme);
  if (items.length === 0) {
    return emptyFallback;
  }
  const alignItems = iconsAlignment === "top" ? "flex-start" : iconsAlignment === "bottom" ? "flex-end" : "center";
  return /* @__PURE__ */ jsx(Stack, { spacing: 1, "data-testid": testId, children: validationItems.map((item, idx) => {
    return /* @__PURE__ */ jsx(
      ValidationSummaryRow,
      {
        item,
        hideIcons,
        alignItems,
        testId: `validation-summary-row_${idx}`,
        validTextColor,
        neutralTextColor,
        invalidTextColor
      },
      item.uid
    );
  }) });
}
export {
  ValidationSummary
};
//# sourceMappingURL=ValidationSummary.js.map
